import MuiTableHead, { TableHeadProps as MuiTableHeadProps } from '@mui/material/TableHead';

export type TableHeadProps = MuiTableHeadProps;

export const TableHead = (props: TableHeadProps) => {
  return <MuiTableHead {...props} />;
};
